// Language configuration shared by the app, SEO component and prerenderer.
//
// ACTIVE_LANGS: languages that are fully translated and allowed to be
//   published/indexed. Danish ('da') is intentionally NOT listed yet —
//   its routes, hreflang tags and sitemap entries must only go live once
//   translations are complete and approved. See DANISH_TRANSLATION_REQUIRED.md.
//
// To publish Danish: add 'da' to ACTIVE_LANGS after the translations in
// i18n/translations.js (da object) are complete.

export const LANG_PREFIX = { en: '', et: '/et', da: '/da' };
export const LANG_LOCALE = { en: 'en_US', et: 'et_EE', da: 'da_DK' };
export const ACTIVE_LANGS = ['en', 'et'];
